(() => {
  if (customElements.get('mb-downpipe-calculator')) return;

  class MartenbrownDownpipeCalculator extends HTMLElement {
    connectedCallback() {
      if (this.mbBound) return;
      const form = this.querySelector('form');
      const input = this.querySelector('[data-circumference]');
      const output = this.querySelector('[data-result]');
      const notes = this.querySelector('[data-notes]');
      const printNotes = this.querySelector('[data-print-notes]');
      const printWrapper = this.querySelector('[data-print-notes-wrapper]');
      if (!form || !input || !output || !notes || !printNotes || !printWrapper) return;

      const initialResult = output.textContent;
      const numberFormat = new Intl.NumberFormat(this.dataset.locale, { maximumFractionDigits: 2, useGrouping: false });
      const decimalSeparator = numberFormat.formatToParts(1.1).find(part => part.type === 'decimal')?.value || '.';
      const resetResult = () => {
        output.textContent = initialResult;
        delete output.dataset.error;
        input.removeAttribute('aria-invalid');
      };
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const raw = input.value.trim();
        const isDecimal = /^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(raw);
        const circumference = isDecimal && raw.length <= 32 ? Number(raw.replace(',', '.')) : NaN;
        const diameter = circumference / Math.PI;
        if (!Number.isFinite(diameter) || circumference <= 0) {
          output.textContent = this.dataset.error;
          output.dataset.error = 'true';
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
        delete output.dataset.error;
        const isTiny = diameter < 0.005;
        const result = isTiny
          ? `${this.dataset.small} ${numberFormat.format(0.01)}`
          : numberFormat.format(diameter);
        const measured = raw.replace(/[.,]/, decimalSeparator);
        const formulaResult = isTiny ? `< ${numberFormat.format(0.01)}` : `≈ ${result}`;
        output.textContent = `${this.dataset.resultLabel}: ${result} mm\n${measured} mm ÷ π ${formulaResult} mm`;
      });
      input.addEventListener('input', resetResult);
      notes.addEventListener('input', () => {
        printNotes.textContent = notes.value;
        printWrapper.hidden = notes.value.trim().length === 0;
      });
      form.addEventListener('reset', () => {
        input.value = '';
        notes.value = '';
        printNotes.textContent = '';
        printWrapper.hidden = true;
        resetResult();
      });
      this.mbBound = true;
      form.hidden = false;
    }
  }

  customElements.define('mb-downpipe-calculator', MartenbrownDownpipeCalculator);
})();
